import { render, staticRenderFns } from "./ocde.vue?vue&type=template&id=6bd09ffb&"
import script from "./ocde.component.ts?vue&type=script&lang=ts&"
export * from "./ocde.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports